'use client';

import { CaretUp } from 'assets/icons';
import { useState } from 'react';
import { useGlobalUI } from 'contexts/GlobalUIContext';
import useScrollspy from 'hooks/scroll/useScrollSpy';
import { Container } from 'components/shared';
import styles from './SecondaryNav.module.css';

export const SecondaryNavbar_BloodVision = ({
  className,
}: {
  className?: string;
}) => {
  const GlobalUI = useGlobalUI();

  const [isMobileNavVisible, setIsMobileNavVisible] = useState(false);

  const setActiveSection = (i: string) => {
    if (!document) return;
    const element = document.getElementById(i);
    if (!element) return;

    const yOffset = -50; // adjust this value to your preferred offset (negative scrolls up)
    const y =
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  type Section = {
    title: string | React.ReactNode;
    id: string;
  };

  const sections: Record<string, Section> = {
    'how-it-works': {
      title: 'How it works',
      id: 'how-it-works',
    },
    'what-is-included': {
      title: "What's included",
      id: 'what-is-included',
    },
    // 'blood-vision-comparision': {
    //   title: 'Compare',
    //   id: 'blood-vision-comparision',
    // },
    'common-questions': {
      title: 'Common Questions',
      id: 'common-questions',
    },
  };

  const activeId = useScrollspy(Object.keys(sections), 60);

  const SecondaryNav = (
    <div className={`${styles.nav} u-hide-scrollbar`}>
      <button
        onClick={() => setActiveSection('how-it-works')}
        className={`${styles.navItem}${
          activeId === 'how-it-works' ? ` ${styles.active}` : ''
        }`}
      >
        {/* What&apos;s in the box */}
        How it works
      </button>
      <button
        onClick={() => setActiveSection('what-is-included')}
        className={`${styles.navItem}${
          activeId === 'what-is-included' ? ` ${styles.active}` : ''
        }`}
      >
        {/* Overview */}
        {"What's included"}
      </button>
      <button
        onClick={() => setActiveSection('common-questions')}
        className={`${styles.navItem}${
          activeId === 'common-questions' ? ` ${styles.active}` : ''
        }`}
      >
        {/* Compare */}
        Common questions
      </button>
    </div>
  );

  const SecondaryNavMobile = (
    <div className={styles.mobileNavColumn}>
      <button
        onClick={() => setActiveSection('how-it-works')}
        className={`${styles.mobileNavItem}${
          activeId === 'how-it-works' ? ` ${styles.active}` : ''
        }`}
        style={{ animationDelay: '0' }}
      >
        {/* What&apos;s in the box */}
        How it works
      </button>
      <button
        onClick={() => setActiveSection('what-is-included')}
        className={`${styles.mobileNavItem}${
          activeId === 'what-is-included' ? ` ${styles.active}` : ''
        }`}
        style={{ animationDelay: '0.05s' }}
      >
        {/* What's Included */}
        {"What's included"}
      </button>

      <button
        onClick={() => setActiveSection('common-questions')}
        className={`${styles.mobileNavItem}${
          activeId === 'common-questions' ? ` ${styles.active}` : ''
        }`}
        style={{ animationDelay: '0.1s' }}
      >
        {/* Compare */}
        Common questions
      </button>
    </div>
  );

  return (
    <div
      className={`${styles.root}${className ? ` ${className}` : ''}`}
      style={{
        top: `${GlobalUI.headerVisible ? GlobalUI.headerHeight : 0}px`,
      }}
    >
      <Container onClick={() => setIsMobileNavVisible(false)} aria-hidden>
        <div className={`${styles.content} d-sm-none`}>{SecondaryNav}</div>
        <div
          className={`${styles.contentMobile} d-lg-none`}
          onClick={(e) => {
            e.stopPropagation();
            setIsMobileNavVisible((prev) => !prev);
          }}
          aria-hidden
        >
          <p className={styles.sectionTitleVisible}>
            {sections[activeId]?.title}{' '}
            <CaretUp
              fill="#000000"
              style={{ transform: 'rotate(180deg)', height: '8px' }}
            />
          </p>
          {isMobileNavVisible ? (
            <div className={styles.mobileNav}>{SecondaryNavMobile}</div>
          ) : null}
        </div>
      </Container>
    </div>
  );
};
